import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export function useThemeMode() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    const stored = localStorage.getItem('jobq-theme-mode');
    return stored || 'light';
  });

  const isDark = mode === 'dark';

  const toggleMode = useCallback(() => {
    setMode((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('jobq-theme-mode', next);
      return next;
    });
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', mode);
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, isDark, toggleMode }}>
      {children}
    </ThemeContext.Provider>
  );
}
